export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "search.worker-be491532e621015e8b08.worker.js");
}
